import { useEffect, useRef } from 'react';
import { useDidUpdate, usePrevious } from 'seagull';
import { useStore } from '~/contexts';
import { useIoContext } from '~/providers/IoContext';
import { useFeatureFlags } from './useFeatureFlags';
import { useRegisterMobileNotification } from './useRegisterMobileNotification';
import { useUnregisterMobileNotification } from './useUnregisterMobileNotification';
export const useNativePush = ()=>{
    const { native } = useIoContext();
    const { NATIVE_PUSH } = useFeatureFlags();
    const authToken = useStore((state)=>state.authToken);
    const pushEnabled = !!NATIVE_PUSH && native.push.isAvailable && authToken != null;
    const previousAuthToken = usePrevious(authToken);
    const { registerMobileNotification } = useRegisterMobileNotification();
    const { unregisterMobileNotification } = useUnregisterMobileNotification();
    const lastEmittedToken = useRef(null);
    const lastPostedToken = useRef(null);
    useDidUpdate(()=>{
        if (authToken == null && previousAuthToken != null) {
            const info = lastEmittedToken.current;
            if (info != null) {
                unregisterMobileNotification({
                    token: info.token,
                    platform: info.platform,
                    authToken: previousAuthToken
                });
            }
        }
    }, [
        authToken
    ]);
    useEffect(()=>{
        if (pushEnabled) {
            const { push } = native;
            const onToken = (info)=>{
                lastEmittedToken.current = info;
                if (info.token === lastPostedToken.current) {
                    return;
                }
                registerMobileNotification(info, {
                    onSuccess: ()=>{
                        lastPostedToken.current = info.token;
                    }
                });
            };
            const removeTokenListenerPromise = push.registerTokenListener(onToken);
            void removeTokenListenerPromise.then(()=>push.requestPermissionAndRegister()).catch(()=>undefined);
            const removeResumeListener = native.lifecycle.registerResumeListener(()=>{
                void push.requestPermissionAndRegister().catch(()=>undefined);
            });
            return ()=>{
                void removeTokenListenerPromise.then((removeListener)=>removeListener()).catch(()=>undefined);
                removeResumeListener();
            };
        }
        return undefined;
    }, [
        pushEnabled,
        registerMobileNotification
    ]);
};
